


export type TodoHistoryType = 'Creation' | 'CreationChild' | 'Change' | 'Comment' | 'Completed' | 'CreationFromForm' | 'CreationFromFormChild';

export const TodoHistoryType = {
    Creation: 'Creation' as TodoHistoryType,
    CreationChild: 'CreationChild' as TodoHistoryType,
    Change: 'Change' as TodoHistoryType,
    Comment: 'Comment' as TodoHistoryType,
    Completed: 'Completed' as TodoHistoryType,
    CreationFromForm: 'CreationFromForm' as TodoHistoryType,
    CreationFromFormChild: 'CreationFromFormChild' as TodoHistoryType
};

